const ptOverrides = {
  'company logo': 'logotipo da empresa',
  'adjust company logo': 'ajustar logotipo',
  'notification preferences': 'preferências de notificações',
  'choose how to receive each type of notification': 'escolha como receber cada tipo de notificação',
  'save preferences': 'salvar preferências',
  'loading preferences': 'carregando preferências',
  'notification preferences updated': 'preferências de notificações atualizadas',
  'notification preferences could not be loaded': 'não foi possível carregar as preferências de notificações',
  'notification preferences could not be saved': 'não foi possível salvar as preferências de notificações',
  'inside Jobifull': 'dentro da Jobifull',
  'push notifications': 'notificações push',
  'not available': 'indisponível',
  'application status updates': 'atualizações de candidaturas',
  'new job applications': 'novas candidaturas às suas vagas',
  'company recruiter invitations': 'convites para equipes de recrutamento',
  'recruitment assignments': 'vagas atribuídas à equipe',
  'vacancy expiration updates': 'encerramento e renovação de vagas',
  'the active profile changed; reload before saving': 'o perfil ativo mudou; recarregue antes de salvar',
  'publication period': 'prazo de publicação',
  'the vacancy will be closed automatically on this date': 'a vaga será encerrada automaticamente nesta data',
  'expiration date': 'data de encerramento',
  'save expiration date': 'salvar prazo',
  'renew for 30 days': 'renovar por 30 dias',
  'renewals': 'renovações',
  'publication period updated': 'prazo salvo',
  'could not load publication period': 'não foi possível carregar o prazo de publicação',
  'could not save publication period': 'não foi possível salvar o prazo de publicação',
  'choose a future expiration date': 'escolha uma data de encerramento futura',
  'could not validate the request; please try again': 'não foi possível validar a solicitação. Tente novamente',
  'manage jobs': 'gerenciar vagas',
  'job sections': 'seções da vaga',
  'job information': 'informações da vaga',
  'save draft': 'salvar rascunho',
  dashboard: 'painel',
  'team members': 'membros',
  'create job': 'criar vaga',
  jobs: 'vagas',
  'new job': 'nova vaga',
  interviews: 'entrevistas',
  'application funnel': 'funil de candidaturas',
  'my reports': 'minhas denúncias',
  subscription: 'assinatura',
  'invite people': 'convidar pessoas',
  'accept a company invitation to view and manage jobs':
    'aceite um convite de empresa para visualizar e gerenciar vagas',
  'accepted formats are: jpeg, png and gif':
    'os formatos aceitos são: JPEG, PNG e GIF',
  actions: 'ações',
  'active company': 'empresa ativa',
  add: 'adicionar',
  'add at': 'adicionar em',
  'add language': 'adicionar idioma',
  'added at': 'adicionado em',
  'already applied': 'candidatura já realizada',
  'action not completed with success': 'não foi possível concluir a ação',
  'action not performed': 'ação não realizada',
  'action performed': 'ação realizada',
  'applied with success': 'candidatura realizada com sucesso',
  applied: 'candidatura enviada',
  accepted: 'aceita',
  'an error occurred please try again': 'ocorreu um erro; tente novamente',
  'authentication expired': 'sua sessão expirou',
  'back to editor': 'voltar ao editor',
  'be more specific': 'seja mais específico',
  'benefit removed successfully': 'benefício removido com sucesso',
  'by clicking': 'ao clicar',
  'certificate link': 'link do certificado',
  'certification deleted': 'certificação excluída',
  'certification not found': 'certificação não encontrada',
  'certification removed': 'certificação removida',
  'chat message not removed': 'não foi possível remover a mensagem',
  'chat message removed': 'mensagem removida',
  change: 'alterar',
  'complete each section to build your professional profile':
    'preencha cada seção para criar seu perfil profissional',
  'complete professional curriculum': 'currículo profissional completo',
  'company benefit not found': 'benefício da empresa não encontrado',
  'company context changed': 'empresa ativa alterada',
  'company found': 'empresa encontrada',
  'company not updated': 'não foi possível atualizar a empresa',
  'company or recruiter profile not found':
    'perfil de empresa ou recrutador não encontrado',
  'country not found': 'país não encontrado',
  currency: 'moeda',
  current: 'atual',
  currently: 'atualmente',
  curriculum: 'currículo',
  'curriculum could not be loaded': 'não foi possível carregar o currículo',
  'curriculum file is required': 'o arquivo do currículo é obrigatório',
  'curriculum not created': 'não foi possível criar o currículo',
  'curriculum not found': 'currículo não encontrado',
  'curriculum not removed': 'não foi possível remover o currículo',
  'curriculum not updated': 'não foi possível atualizar o currículo',
  'curriculum removed': 'currículo removido',
  'curriculum editor': 'editor de currículo',
  'curriculum preview': 'visualização do currículo',
  'dashboard could not be loaded': 'não foi possível carregar o painel',
  edit: 'editar',
  'email is invalid': 'o e-mail informado é inválido',
  'email or password invalid': 'e-mail ou senha inválidos',
  'email already in use': 'este e-mail já está em uso',
  'email already verified': 'este e-mail já foi verificado',
  'email not sent': 'não foi possível enviar o e-mail',
  'email not verified': 'e-mail não verificado',
  'email sent': 'e-mail enviado',
  'email verified': 'e-mail verificado',
  'enter a professional phone to match the selected ddi':
    'informe um telefone profissional para o DDI selecionado',
  experiences: 'experiências',
  'export pdf': 'exportar PDF',
  'feel free to try again using one of our filters at':
    'tente novamente usando um de nossos filtros em',
  'fill in all required fields': 'preencha todos os campos obrigatórios',
  'find the international jobs you':
    'encontre as vagas internacionais que você',
  'find the right company': 'encontre a empresa certa',
  'first name': 'nome',
  'generating pdf': 'gerando PDF',
  hours: 'horas',
  'houve um erro ao buscar os seus currículos':
    'houve um erro ao buscar os seus currículos',
  'idioma do curriculo': 'idioma do currículo',
  'if it is not listed, type the custom value':
    'se não estiver na lista, digite um valor personalizado',
  'if an account exists for this email, a password reset link was sent':
    'se existir uma conta para este e-mail, enviamos um link para redefinir a senha',
  'issue date': 'data de emissão',
  'issuing organization': 'organização emissora',
  'invalid action': 'ação inválida',
  'invalid code': 'código inválido',
  'invalid ddi': 'DDI inválido',
  'invalid email': 'e-mail inválido',
  'invalid profile type': 'tipo de perfil inválido',
  'invitation accepted': 'convite aceito',
  'invitation already accepted': 'convite já aceito',
  'invitation already decided': 'convite já respondido',
  'invitation already declined': 'convite já recusado',
  'invitation declined': 'convite recusado',
  'invitation not found': 'convite não encontrado',
  job: 'vaga',
  'job certification': 'certificação da vaga',
  'job invitations': 'convites de vagas',
  'job not found': 'vaga não encontrada',
  'job removed from trash': 'vaga removida da lixeira',
  'job sent to trash': 'vaga enviada para a lixeira',
  'job updated successfully': 'vaga atualizada com sucesso',
  'last name': 'sobrenome',
  'manage companies': 'gerenciar empresas',
  'manage company': 'gerenciar empresa',
  'manage recruiters': 'gerenciar recrutadores',
  'max allowed size is 2 mb': 'o tamanho máximo permitido é 2 MB',
  'maximum of 64 characters': 'máximo de 64 caracteres',
  'meus curriculos': 'meus currículos',
  mostrando: 'mostrando',
  'no certifications': 'nenhuma certificação',
  'no company linked': 'nenhuma empresa vinculada',
  'no curriculum found': 'nenhum currículo encontrado',
  'no information added yet': 'nenhuma informação adicionada ainda',
  'no notifications found': 'nenhuma notificação encontrada',
  'no recruiter found': 'nenhum recrutador encontrado',
  'no recruiter selected': 'nenhum recrutador selecionado',
  'new application status': 'novo status da candidatura',
  'no references': 'nenhuma referência',
  'not authorized for this company':
    'você não tem autorização para esta empresa',
  notifications: 'notificações',
  'notifications could not be loaded':
    'não foi possível carregar as notificações',
  'loading notifications': 'carregando notificações',
  'unread notifications': 'notificações não lidas',
  'mark all as read': 'marcar todas como lidas',
  'mark as read': 'marcar como lida',
  all: 'todas',
  unread: 'não lidas',
  read: 'lidas',
  previous: 'anterior',
  next: 'próxima',
  'view details': 'ver detalhes',
  'view applicants': 'ver candidaturas',
  'your application status changed': 'o status da sua candidatura mudou',
  'a professional applied to your job':
    'um profissional se candidatou à sua vaga',
  'company recruiter invitation': 'convite para recrutador da empresa',
  'ops! houve um problema, actualize a página':
    'ops! houve um problema, atualize a página',
  'ops! nenhum resultado foi encontrado':
    'ops! nenhum resultado foi encontrado',
  'organizar por': 'organizar por',
  'password must contain at least 6 characters':
    'a senha deve conter pelo menos 6 caracteres',
  'password must contain at most 64 characters':
    'a senha deve conter no máximo 64 caracteres',
  'passwords do not match': 'as senhas não correspondem',
  "passwords doesn't match.": 'as senhas não correspondem.',
  'person not created': 'não foi possível criar a pessoa',
  'person not updated': 'não foi possível atualizar a pessoa',
  'pdf could not be generated': 'não foi possível gerar o PDF',
  'perfil empresa': 'perfil da empresa',
  'please enter a ddi for the contact phone':
    'informe o DDI do telefone de contato',
  'please enter a phone number': 'informe um número de telefone',
  'preview curriculum': 'visualizar currículo',
  'professional cover photo updated': 'foto de capa profissional atualizada',
  'professional email is required': 'o e-mail profissional é obrigatório',
  'professional experiences': 'experiências profissionais',
  'professional first name is required': 'o nome do profissional é obrigatório',
  'professional info updated': 'informações profissionais atualizadas',
  'professional information': 'informações profissionais',
  'professional last name is required':
    'o sobrenome do profissional é obrigatório',
  'professional logo updated': 'foto profissional atualizada',
  'professional skills': 'competências profissionais',
  'professional title is required': 'o título profissional é obrigatório',
  'professional not found': 'profissional não encontrado',
  'professional not updated': 'não foi possível atualizar o profissional',
  'professional profile not found': 'perfil profissional não encontrado',
  'proficiency level is required': 'o nível de proficiência é obrigatório',
  profile: 'perfil',
  'profile changed': 'perfil alterado',
  'recruiter information': 'informações do recrutador',
  refused: 'recusada',
  'recruiter not updated': 'não foi possível atualizar o recrutador',
  'recruiter profile not found': 'perfil de recrutador não encontrado',
  'remember email': 'lembrar e-mail',
  'post job': 'publicar vaga',
  'skip to main content': 'pular para o conteúdo principal',
  'remove job from trash': 'remover vaga da lixeira',
  resultados: 'resultados',
  selecionar: 'selecionar',
  'select a ddi to match the professional phone':
    'selecione um DDI para o telefone profissional',
  'select a job contract': 'selecione um contrato de trabalho',
  'select a job period': 'selecione um período de trabalho',
  'select a modality': 'selecione uma modalidade',
  'select a paying type': 'selecione uma forma de pagamento',
  'select a profession': 'selecione uma profissão',
  'select a type': 'selecione um tipo',
  'select a working visa': 'selecione uma autorização de trabalho',
  'select job': 'selecionar vaga',
  'select proficiency level': 'selecione o nível de proficiência',
  'send invitation': 'enviar convite',
  'skill not found': 'competência não encontrada',
  'skill removed': 'competência removida',
  'social network not found': 'rede social não encontrada',
  'social network updated successfully': 'rede social atualizada com sucesso',
  'social networks': 'redes sociais',
  'social type': 'tipo de rede social',
  tasks: 'tarefas',
  'there was an error deleting your certification':
    'houve um erro ao excluir sua certificação',
  'this field must be at most 100 characters':
    'este campo deve ter no máximo 100 caracteres',
  'this field must be at most 400 characters':
    'este campo deve ter no máximo 400 caracteres',
  'this field must be at most 500 characters':
    'este campo deve ter no máximo 500 caracteres',
  tipo: 'tipo',
  to: 'até',
  'to work': 'trabalhar',
  'try again': 'tentar novamente',
  'type or choose a certification': 'digite ou escolha uma certificação',
  'type or choose a skill': 'digite ou escolha uma competência',
  'type the name or email of the recruiter':
    'digite o nome ou e-mail do recrutador',
  update: 'atualizar',
  url: 'URL',
  'user not found': 'usuário não encontrado',
  'user not logged': 'usuário não autenticado',
  'ver perfil': 'ver perfil',
  'view certificate': 'ver certificado',
  'view job': 'ver vaga',
  visualizar: 'visualizar',
  validating: 'em análise',
  wait: 'aguarde',
  'your skill was deleted': 'sua competência foi excluída',
  'add structured professional information before calculating this score':
    'adicione informações profissionais estruturadas antes de calcular esta pontuação',
  'algorithm version': 'versão do algoritmo',
  'calculating compatibility': 'calculando a compatibilidade',
  'complete your curriculum to see compatibility':
    'complete seu currículo para ver a compatibilidade',
  'compatibility is temporarily unavailable':
    'a compatibilidade está temporariamente indisponível',
  'compatibility score': 'pontuação de compatibilidade',
  'certifications and licenses': 'certificações e licenças',
  'data coverage': 'cobertura dos dados',
  'gaps to review': 'lacunas para revisar',
  'important requirement not met': 'requisito importante não atendido',
  'job requirement': 'requisito da vaga',
  'not enough data to calculate the score':
    'não há dados suficientes para calcular a pontuação',
  'positive factors': 'fatores positivos',
  'required skills': 'competências exigidas',
  'some factors could not be evaluated because structured data is missing':
    'alguns fatores não puderam ser avaliados por falta de dados estruturados',
  'this score compares structured job requirements with your curriculum and is not a hiring probability':
    'esta pontuação compara os requisitos estruturados da vaga com seu currículo e não representa uma probabilidade de contratação',
  'try again later without affecting your application':
    'tente novamente mais tarde; isso não afeta sua candidatura',
  'work authorization could not be verified with the available data':
    'não foi possível verificar a autorização de trabalho com os dados disponíveis',
  'work modality and location': 'modalidade e localização do trabalho',
  'your compatibility with this job': 'sua compatibilidade com esta vaga',
  'your curriculum does not currently show the required work authorization':
    'seu currículo não apresenta atualmente a autorização de trabalho exigida',
  'new job alerts': 'alertas de novas vagas',
  'receive a notification when a new job matches your criteria':
    'receba uma notificação quando uma nova vaga combinar com seus critérios',
  'alert name': 'nome do alerta',
  'example backend in madrid': 'ex.: backend em Madrid',
  keyword: 'palavra-chave',
  'job title or description': 'cargo ou descrição',
  city: 'cidade',
  'example madrid': 'ex.: Madrid',
  frequency: 'frequência',
  daily: 'diária',
  weekly: 'semanal',
  'create alert': 'criar alerta',
  'loading alerts': 'carregando alertas',
  'you have not created any job alerts yet':
    'você ainda não criou alertas de vagas',
  'all jobs': 'todas as vagas',
  active: 'ativo',
  paused: 'pausado',
  pause: 'pausar',
  activate: 'ativar',
  delete: 'excluir',
  'new job matching your alert': 'nova vaga compatível com seu alerta',
  'new jobs matching your alerts': 'novas vagas compatíveis com seus alertas',
  'saved search name': 'nome da busca salva',
  'example remote backend': 'ex.: backend remoto',
  'save current search': 'salvar busca atual',
  'loading saved searches': 'carregando buscas salvas',
  'no saved searches yet': 'nenhuma busca salva ainda',
  load: 'carregar',
  rename: 'renomear',
  'adjust image': 'ajustar imagem',
  'adjust cover photo': 'ajustar foto de capa',
  'saving image': 'salvando imagem',
  'save image': 'salvar imagem',
  'choose and adjust the image; saving happens in one step':
    'escolha e ajuste a imagem; ela será salva em uma única etapa',
  'update cover photo': 'atualizar foto de capa',
  'update profile photo': 'atualizar foto de perfil',
  'present your professional identity': 'apresente sua identidade profissional',
  'help recruiters recognize you': 'ajude recrutadores a reconhecer você',
  'adjust profile photo': 'ajustar foto de perfil',
  'choose an image, then adjust the crop before saving':
    'escolha uma imagem e ajuste o recorte antes de salvar',
  'choose another image': 'escolher outra imagem',
  'choose image': 'escolher imagem',
  'drag the image to change its position':
    'arraste a imagem para mudar a posição',
  zoom: 'zoom',
  'horizontal position': 'posição horizontal',
  'vertical position': 'posição vertical',
  'rotate left': 'girar à esquerda',
  'rotate right': 'girar à direita',
  'reset adjustments': 'restaurar ajustes',
  'current image': 'imagem atual',
  'select a jpeg, png or webp image': 'selecione uma imagem JPEG, PNG ou WebP',
  'the original image must be a maximum of 10 mb':
    'a imagem original deve ter no máximo 10 MB',
  'the selected image could not be opened':
    'não foi possível abrir a imagem selecionada',
  'the saved image will use the crop shown above':
    'a imagem salva usará o recorte exibido acima',
  'processing image': 'processando imagem',
  'use this crop': 'usar este recorte',
  'the adjusted image could not be generated':
    'não foi possível gerar a imagem ajustada',
  'remove cover photo': 'remover foto de capa',
  'remove profile photo': 'remover foto de perfil',
  'the image could not be removed': 'não foi possível remover a imagem',
  'image removed successfully': 'imagem removida com sucesso',
  'keep your information, preferences and professional image up to date':
    'mantenha suas informações, preferências e imagem profissional atualizadas',
  'manage the contact and language settings used across your account':
    'gerencie os dados de contato e idioma usados em sua conta',
  'introduce yourself clearly to companies and recruiters':
    'apresente-se com clareza para empresas e recrutadores',
  'professional presentation': 'apresentação profissional',
  'summarize your experience, strengths and career goals':
    'resuma sua experiência, seus pontos fortes e seus objetivos profissionais',
  'what to include': 'o que incluir',
  'your current role and years of experience':
    'sua função atual e seus anos de experiência',
  'your strongest skills and measurable results':
    'suas competências mais fortes e resultados mensuráveis',
  'the opportunity and impact you are looking for':
    'a oportunidade e o impacto que você busca',
  'professional summary': 'resumo profissional',
  'write a concise professional summary':
    'escreva um resumo profissional claro e objetivo',
  preview: 'pré-visualização',
  'save summary': 'salvar resumo',
  'professional summary could not be loaded':
    'não foi possível carregar o resumo profissional',
  'professional summary could not be saved':
    'não foi possível salvar o resumo profissional',
  'professional summary updated': 'resumo profissional atualizado',
  'skills and languages': 'competências e idiomas',
  'manage normalized skills, proficiency levels and languages in your curriculum':
    'gerencie competências normalizadas, níveis de domínio e idiomas em seu currículo',
  'manage skills and languages': 'gerenciar competências e idiomas',
  'profile visibility': 'visibilidade do perfil',
  'choose who can find and view your professional profile':
    'escolha quem pode encontrar e visualizar seu perfil profissional',
  'public profile': 'perfil público',
  'anyone can find and view your professional profile':
    'qualquer pessoa pode encontrar e visualizar seu perfil profissional',
  'companies only': 'somente empresas',
  'only authenticated companies and recruiters can view your profile':
    'somente empresas e recrutadores autenticados podem visualizar seu perfil',
  'private profile': 'perfil privado',
  'only you can view your professional profile':
    'somente você pode visualizar seu perfil profissional',
  'save visibility': 'salvar visibilidade',
  'profile visibility could not be loaded':
    'não foi possível carregar a visibilidade do perfil',
  'profile visibility could not be saved':
    'não foi possível salvar a visibilidade do perfil',
  'profile visibility updated': 'visibilidade do perfil atualizada',
  'current location': 'localização atual',
  'help companies understand where you are currently based':
    'ajude empresas a entender onde você está atualmente',
  'your current city': 'sua cidade atual',
  'save location': 'salvar localização',
  'location could not be loaded': 'não foi possível carregar a localização',
  'location could not be saved': 'não foi possível salvar a localização',
  'select a country for your city': 'selecione um país para sua cidade',
  'location updated': 'localização atualizada',
  education: 'formação',
  'no education': 'nenhuma formação adicionada',
  'presentation field must be at least 50 characters':
    'a apresentação deve ter pelo menos 50 caracteres',
  'presentation field must be at most 3000 characters':
    'a apresentação deve ter no máximo 3.000 caracteres',
  'this curriculum version is used in an application and is read only; duplicate it to make changes':
    'esta versão do currículo já foi usada em uma candidatura e foi preservada; duplique-a para fazer alterações',
  'profile photo': 'foto de perfil',
  'not informed': 'não informado',
  'job applications': 'candidaturas',
  'invitation date': 'data do convite',
  'accept invitation': 'aceitar convite',
  'refuse invitation': 'recusar convite',
  'no jobs match your search': 'nenhuma vaga corresponde à sua busca',
  'loading teams': 'carregando equipes',
  'editing team': 'editando equipe',
  'save team': 'salvar equipe',
  'saving team': 'salvando equipe',
  'create team': 'criar equipe',
  'edit team': 'editar equipe',
  'could not load teams': 'não foi possível carregar as equipes',
  'could not save team': 'não foi possível salvar a equipe',
  'organizational team': 'equipe organizacional',
  'team assignment does not change individual responsibilities': 'o vínculo com a equipe não altera os responsáveis e colaboradores individuais',
  'no team assigned': 'nenhuma equipe vinculada',
  'create a team in company members first': 'crie uma equipe na área de membros da empresa',
  'team assignment saved': 'vínculo de equipe salvo',
  'save team assignment': 'salvar vínculo da equipe',
  'applied at': 'candidatura enviada em',
  'published at': 'publicado em',
  'checking your application': 'verificando sua candidatura',
  'could not check your application': 'não foi possível verificar sua candidatura',
  'application submitted successfully': 'candidatura enviada com sucesso',
  'responsible team': 'responsáveis pela seleção',
  'responsible': 'responsável',
  'collaborators': 'colaboradores',
  'no responsible selected': 'nenhum responsável selecionado',
  'save assignments': 'salvar responsáveis',
  'no active company members': 'nenhum membro ativo na empresa',
  'define who is responsible for this job and who collaborates in the selection': 'defina quem é responsável por esta vaga e quem colabora na seleção',
  'job content preview': 'prévia do conteúdo da vaga',
  'this preview does not save or publish the job': 'esta prévia mostra o conteúdo em edição, sem salvar nem publicar a vaga',
  'return to editing': 'voltar à edição',
  'untitled job': 'vaga sem título',
  'job modality': 'modalidade de trabalho',
  'job description': 'descrição da vaga',
  'working hours': 'jornada de trabalho',
  'salary': 'salário',
  'contract': 'contrato',
  'company vacancies': 'vagas da empresa',
  'application questions': 'perguntas de candidatura',
  'collect comparable answers before the application reaches the recruitment team': 'reúna respostas comparáveis antes de a candidatura chegar à equipe de recrutamento',
  'add question': 'adicionar pergunta',
  'remove question': 'remover pergunta',
  'no application questions configured': 'nenhuma pergunta de candidatura configurada',
  'question': 'pergunta',
  'answer type': 'tipo de resposta',
  'free text': 'texto livre',
  'yes or no': 'sim ou não',
  'single choice': 'escolha única',
  'eliminatory': 'eliminatória',
  'options separated by lines': 'opções, uma por linha',
  'accepted answer': 'resposta aceita',
  'write every question before saving': 'escreva todas as perguntas antes de salvar',
  'choose the accepted answer for every eliminatory question': 'escolha a resposta aceita de cada pergunta eliminatória',
  'loading application questions': 'carregando perguntas de candidatura',
  'could not load application questions': 'não foi possível carregar as perguntas de candidatura',
  'could not save application questions': 'não foi possível salvar as perguntas de candidatura',
  'application questions saved': 'perguntas de candidatura salvas',
  'answer all required application questions': 'responda a todas as perguntas obrigatórias da candidatura',
  'could not load curricula for this application': 'não foi possível carregar os currículos para esta candidatura; tente novamente',
  'choice questions must include at least one option': 'perguntas de escolha única precisam de pelo menos uma opção',
  'questions are locked because this job already has applications': 'as perguntas estão bloqueadas porque esta vaga já recebeu candidaturas',
  'you do not have permission to edit application questions': 'você não tem permissão para editar as perguntas de candidatura',
  'search company vacancies': 'pesquisar vagas da empresa',
  'manage drafts, published jobs and applications in one place': 'gerencie rascunhos, vagas publicadas e candidaturas em um só lugar',
};

export default ptOverrides;
